import React from 'react';
import styles from './Password.module.scss';
import logo from './logo.png';
import { TextField } from '@mui/material';
import { Link } from 'react-router-dom';

const Password = () => {
    return (
        <div className={styles.passwordContainer}>
            <div className={styles.contentCont}>

                <img src={logo} alt="Logo" className={styles.logoImage} />
                <div className={styles.forgotPasswordContainer}>
                    <div>
                        <h1>Forgot Your Password?</h1>
                        <p>Enter your email address and we will send you instructions to reset your password.</p>
                    </div>
                    <div>
                        <form action="/password-reset" method="post">
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                sx={{
                                    fontSize: {
                                        xs: "16px",
                                        sm: "18px",
                                        md: "20px",
                                    }
                                }}
                            />
                            <button type="button" className={styles.submitButton}>Continue</button>
                        </form>
                    </div>
                    <a href="login" className={styles.backLink}>Back to Login </a>
                </div>
            </div>

        </div>
    );
};

export default Password;

